export enum MacroType {
  Hospitals = 1,
  Location = 2,
  Provider = 3,
}

export enum MacroTargetType {
  All = -1,
  ExamVisit = 1,
  Sms = 2,
}
